import { put, select, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from 'Domain/App/Ducks/Table.duck';
import RelationService from '../Services/RelationService';

export const actionTypes = {
  RequestData: '[Customers Invoices Tab] Request Invoice',
  FulfilledTable: '[Customers Invoices Tab] FulfilledCustomers invoices',
  SearchTable: '[Customers Invoices Tab] Search customers invoices',
  ChangePage: '[Customers Invoices Tab] change page',
  SetPageSize: '[Customers Invoices Tab] set page size',
  SortTable: '[Customers Invoices Tab] Sort customers invoices',
  ApplyFilter: '[Customers Invoices Tab] Apply filter',
  RemoveFilter: '[Customers Invoices Tab] Remove filter',
  ResetFilters: '[Customers Invoices Tab] Reset filter',
};

const initialState = {
  ...tableInitialState,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);
  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    const customerId = yield select(state => state.CustomerInvoicesReducer.customerId);

    yield put(actions.requestData({ customerId }));
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* customerQuotesSaga({ data: { customerId } }) {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);
    const currentState = yield select(state => state.CustomerInvoicesReducer);
    const response = yield RelationService.fetchAllInvoices(
      currentTenantId,
      customerId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
    );
    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });
}
